import { Component, Input, Output, EventEmitter, HostBinding, booleanAttribute, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ToastPosition, ToastTone } from './toast.types';
import { IconHelperService } from '../../icon-helper/icon-helper.service';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToastComponent {
  constructor(
    private iconHelperService: IconHelperService,
    private sanitizer: DomSanitizer
  ) {}
  @Input() title?: string;
  @Input() message: string = '';
  @Input() tone: ToastTone = 'neutral';
  @Input() position: ToastPosition = 'top-right';
  
  @Input({ transform: booleanAttribute }) showHeader: boolean = true;
  @Input({ transform: booleanAttribute }) showMessage: boolean = true;
  @Input({ transform: booleanAttribute }) showLeftIcon: boolean = true;
  @Input({ transform: booleanAttribute }) isProcess: boolean = false;
  @Input({ transform: booleanAttribute }) isRemoving: boolean = false;

  @Output() closeToast = new EventEmitter<void>();

  @HostBinding('class')
  get hostClasses(): string {
    return `app-toast app-toast--${this.tone} app-toast--${this.position}${this.isRemoving ? ' app-toast--removing' : ''}`;
  }

  getLeftIconSvg(): SafeHtml | null {
    const iconName = this.getLeftIconName();
    const svg = this.iconHelperService.get(iconName);
    return svg ? this.sanitizer.bypassSecurityTrustHtml(svg) : null;
  }

  getCloseIconSvg(): SafeHtml | null {
    const svg = this.iconHelperService.get('times');
    return svg ? this.sanitizer.bypassSecurityTrustHtml(svg) : null;
  }

  getLeftIconName(): string {
    switch (this.tone) {
      case 'success': return 'check';
      case 'warning': return 'warning';
      case 'error': return 'times';
      case 'neutral': return this.isProcess ? 'spinner-dotted' : 'info-circle';
      default: return 'info-circle';
    }
  }

  onClose(): void {
    if (!this.isProcess) {
      this.closeToast.emit();
    }
  }
}
